// extracted by mini-css-extract-plugin
export default {"countdown":"_63ed515b"};